const en = {
  code: "en",
  meta: {
    home: {
      title: "Bloom Beauty Concept Hair | Hair Salon in Venda do Pinheiro",
      desc: "Specialist in highlights, balayage, colour, treatments, hair alignment and straightening in Venda do Pinheiro. Book your assessment with Monique Santos.",
    },
    sobre: {
      title: "About Monique Santos | Bloom Beauty Concept Hair",
      desc: "Meet Monique Santos, the hairstylist behind Bloom Beauty Concept Hair in Venda do Pinheiro. Personalised care and hair health first.",
    },
    servicos: {
      title: "Services | Bloom Beauty Concept Hair — Venda do Pinheiro",
      desc: "Cuts, colour, highlights and balayage, colour correction, treatments, hair schedule, botox, alignment and straightening in Venda do Pinheiro.",
    },
    avaliacao: {
      title: "Professional Assessment | Bloom Beauty Concept Hair",
      desc: "Every transformation begins with a proper assessment: hair diagnosis, chemical history, strand test and a personalised plan. Book via WhatsApp.",
    },
    transformacoes: {
      title: "Transformations | Bloom Beauty Concept Hair",
      desc: "Real results in highlights, balayage, colour, alignment and straightening at Bloom Beauty Concept Hair, Venda do Pinheiro.",
    },
    galeria: {
      title: "Gallery | Bloom Beauty Concept Hair",
      desc: "The space, the details and the work of Bloom Beauty Concept Hair in Venda do Pinheiro.",
    },
    contato: {
      title: "Contact | Bloom Beauty Concept Hair — Venda do Pinheiro",
      desc: "Rua Casal dos Ninhos 1B, Venda do Pinheiro. WhatsApp +351 963 085 891. Mon–Fri 09:00–19:00, Sat 09:30–18:00.",
    },
    privacidade: {
      title: "Privacy Policy | Bloom Beauty Concept Hair",
      desc: "Privacy and data protection policy of Bloom Beauty Concept Hair.",
    },
  },
  nav: {
    home: "Home", about: "About", services: "Services", transformations: "Transformations",
    gallery: "Gallery", contact: "Contact", book: "Book Assessment", menu: "Menu", close: "Close",
  },
  common: {
    learnMore: "Learn more", bookEval: "Book assessment", bookService: "Book appointment",
    whatsapp: "WhatsApp", instagram: "Instagram", directions: "Get directions", call: "Call",
    send: "Send request", sending: "Sending…", viewServices: "Explore services",
    seeTransformations: "See transformations", seeGallery: "View gallery", all: "All",
    backToServices: "Back to services",
    includedNote: "No prices online: every hair is unique. Quotes are given after assessment or via WhatsApp.",
    soonGoogle: "Coming soon — we are preparing our Google profile.",
  },
  home: {
    heroEyebrow: "Bloom Beauty Concept Hair — Venda do Pinheiro",
    heroLines: ["Hair that reveals", "your very best", "self."],
    heroText: "Specialist in colour, illumination, treatments, alignment and hair transformation in Venda do Pinheiro.",
    ctaPrimary: "Book Assessment",
    ctaSecondary: "Explore Services",
    scroll: "Scroll to discover",
    marquee: ["Highlights & Balayage", "Colour", "Hair Treatments", "Alignment", "Straightening", "Cut & Styling"],
    welcome: {
      eyebrow: "Welcome to Bloom",
      title: "A beauty concept made to measure",
      p: "Bloom Beauty Concept Hair was born to offer a personalised beauty experience, where every hair is individually assessed and every transformation respects each client's identity, hair health and wishes.",
      tag: "We enhance your beauty, we reveal your essence.",
    },
    specialties: {
      eyebrow: "Specialties",
      title: "What we can do for your hair",
      sub: "Personalised techniques, professional products and a watchful eye on hair health.",
    },
    monique: {
      eyebrow: "The Hairstylist",
      title: "Meet Monique Santos",
      p1: "Behind Bloom is Monique Santos, a hairstylist passionate about enhancing the beauty and identity of every woman.",
      p2: "Every appointment begins with a careful analysis of the hair, its chemical history, the client's goals and the health of the strands. The goal is not only to transform the look, but to create beautiful, personalised and sustainable results.",
      cta: "Meet Monique",
    },
    transformations: {
      eyebrow: "Portfolio",
      title: "Transformations that speak for themselves.",
      p: "Every hair has a story. Every result is built in a personalised way.",
    },
    experience: {
      eyebrow: "The Bloom Experience",
      title: "Every detail, designed for you",
      steps: [
        { n: "01", t: "Individual assessment", d: "Before any technique, we listen to your story and analyse your hair." },
        { n: "02", t: "Personalised technique", d: "Every service is adapted to your strands, your face and your lifestyle." },
        { n: "03", t: "Professional products", d: "We work with professional ranges chosen for each need." },
        { n: "04", t: "Hair health care", d: "Lasting beauty only exists with healthy strands — always." },
      ],
    },
    evaluation: {
      eyebrow: "Professional Assessment",
      title: "Everything begins with a proper assessment.",
      p: "Certain procedures require a professional analysis before any transformation. That is how we protect the health of your strands and guarantee the right result for you.",
      items: [
        "Hair diagnosis", "Scalp analysis", "Chemical history", "Client's goal",
        "Personalised plan", "Strand test when needed", "Time estimate", "Professional guidance",
      ],
      cta: "Book my assessment",
    },
    salon: {
      eyebrow: "The Salon",
      title: "A space created to care for you.",
      p: "A warm and elegant environment where every detail was designed to turn your beauty moment into a special experience.",
    },
    quote: "Caring for your hair is more than aesthetics. It is self-esteem, it is remembering yourself.",
    final: {
      title: "Ready to live the Bloom experience?",
      p: "Speak directly with Monique and book your assessment.",
      cta: "Book via WhatsApp",
    },
    quotes: [
      "Care for yourself with the same tenderness you offer others.",
      "Your beauty begins when you recognise your own worth.",
      "New hair can be the start of a new energy.",
      "Save a moment for yourself. You deserve it.",
      "Enhance your beauty. Reveal your essence.",
      "When you feel good about yourself, it shows on the outside.",
      "Bloom in your own beauty.",
    ],
  },
  about: {
    eyebrow: "About",
    title: "More than hair. An experience of care.",
    p1: "Behind Bloom Beauty Concept Hair is Monique Santos, a hairstylist passionate about enhancing the beauty and identity of every woman who sits in her chair.",
    p2: "Every appointment begins with a careful analysis of the hair, its chemical history, the client's goals and the health of the strands. The goal is not only to transform the look, but to create beautiful, personalised and sustainable results — that make sense in everyday life.",
    p3: "At Bloom, we believe true transformation begins when every woman chooses herself, cares for herself and honours herself. Here, every detail is designed to enhance who you already are.",
    philosophyTitle: "My philosophy",
    philosophy: "Every woman has a unique beauty. My work is to understand her style, her hair and the result she wants to achieve, to create a transformation that respects her identity.",
    valuesTitle: "What you can expect",
    values: [
      { t: "True listening", d: "Your wishes and your routine are the starting point of every proposal." },
      { t: "Hair health first", d: "No transformation is worth the health of your strands." },
      { t: "Constant updating", d: "Evolving techniques and products, at the service of your hair." },
      { t: "Transparency", d: "Honest assessment, no impossible promises." },
    ],
    coursesEyebrow: "Professional training",
    coursesTitle: "Monique Santos is also an educator",
    coursesText: "Alongside salon appointments, Monique also teaches professional courses in hair treatments and straightening.",
    courseHairTreatments: "Hair Treatments Course",
    courseStraightening: "Straightening Course",
    lorenaEyebrow: "Bloom Professional",
    lorenaTitle: "Meet Lorena",
    lorenaText: "Lorena is part of the Bloom team and is professionally trained in laser hair removal and facial cleansing, offering dedicated and personalised care.",
    lorenaLaser: "Laser Hair Removal",
    lorenaSkin: "Facial Cleansing",
    cta: "Talk to Monique",
    quote: "Your beauty blossoms.",
  },
  servicesPage: {
    eyebrow: "Services",
    title: "A care menu for every hair",
    sub: "Explore each specialty. Every service begins with listening and, when needed, a professional assessment — which is why we do not show prices online.",
  },
  services: {
    "cortes-finalizacao": {
      name: "Cuts & Styling",
      short: "Cuts and styling that respect your face and the natural movement of your hair.",
      desc: "Cuts and finishes designed to flatter your face shape, the movement of the hair and each client's style.",
      items: [
        "Women's haircut", "Cut + blow-dry", "Cut + brushing", "Men's haircut",
        "Fringe / cut adjustment", "Simple blow-dry", "Brushing — short hair",
        "Brushing — medium hair", "Brushing — long hair",
        "Brushing — extra long or dense hair", "Flat iron / sleek finish", "Waves / styling",
      ],
      cta: "Book appointment",
    },
    coloracao: {
      name: "Colour",
      short: "Personalised colour that flatters your skin, style and identity.",
      desc: "Colour developed in a personalised way to enhance each client's skin, style and identity.",
      note: "Some services may require a prior assessment.",
      items: [
        "Root colour", "Full colour — short hair", "Full colour — medium hair",
        "Full colour — long hair", "Full colour — extra long or dense hair",
        "Toning / Gloss", "Shine bath", "Grey coverage", "Colour + cut + blow-dry",
      ],
      cta: "Book appointment",
    },
    "mechas-balayage": {
      name: "Illumination, Highlights & Balayage",
      short: "Made-to-measure illumination: from subtle babylights to full blonde.",
      desc: "Illumination created according to the cut, skin tone, the hair's natural base and the client's goal.",
      note: "Colour transformations may require an assessment and a strand test.",
      items: [
        "Partial highlights", "Full highlights", "Balayage", "Premium Balayage",
        "Contour / Face Framing", "Partial illumination", "Full Blonde", "Babylights",
        "Highlights + toning + blow-dry",
      ],
      cta: "Book assessment",
    },
    "correcao-de-cor": {
      name: "Colour Correction",
      short: "Recover, rebalance and rebuild colour safely.",
      desc: "Correcting colour is a technical process that demands diagnosis, strategy and respect for the hair fibre. Every case is studied individually.",
      note: "Complex correction services must be assessed individually.",
      items: [
        "Simple colour correction", "Medium colour correction", "Complex colour correction",
        "Global lightening", "Pigment removal", "Colour transformation", "Correction + reconstruction",
      ],
      cta: "Book assessment",
    },
    "tratamentos-capilares": {
      name: "Hair Treatments",
      short: "Hydration, nutrition and reconstruction for visibly healthy hair.",
      desc: "Treatment rituals chosen according to your hair's real needs — because no strand is like another.",
      items: [
        "Hydration", "Nutrition", "Reconstruction", "Anti-frizz treatment", "Hair detox",
        "Cauterization", "Intensive reconstruction", "Premium treatment", "Treatment + blow-dry",
      ],
      highlights: [
        { t: "Hydration", d: "Water replacement for soft, flexible strands." },
        { t: "Nutrition", d: "Lipid replacement for shine and discipline." },
        { t: "Reconstruction", d: "Mass and protein replacement for strength and structure." },
      ],
      cta: "Book appointment",
    },
    "cronograma-capilar": {
      name: "Hair Care Schedule",
      short: "A session plan designed for your hair's recovery.",
      desc: "A sequential care programme combining hydration, nutrition and reconstruction in the exact measure of your strands.",
      items: ["3-session schedule", "4-session schedule", "Premium schedule", "Single session"],
      process: ["Assessment", "Diagnosis", "Personalised plan", "Sessions", "Maintenance"],
      cta: "Book assessment",
    },
    "botox-alinhamento": {
      name: "Botox & Alignment",
      short: "Aligned, shiny, frizz-free strands — with Bloom technology.",
      desc: "From hair botox to Bloom Realignment: alignment technologies that restore discipline, shine and softness while respecting hair health.",
      note: "Options vary with hair length and density — defined during assessment.",
      items: ["Hair botox", "Premium botox", "Sealing", "Alignment", "Anti-frizz treatment"],
      cta: "Book assessment",
    },
    "progressiva-alisamentos": {
      name: "Straightening & Smoothing",
      short: "Naturally straight, with movement and frizz-free, every day.",
      desc: "Aligned, shiny, soft and frizz-free hair, every day. The right technique — progressiva, organic or premium straightening — is chosen after assessing the strands.",
      note: "Services are separated by length and density — quotes only after assessment.",
      items: ["Progressiva (Brazilian blowout)", "Organic straightening", "Premium straightening", "Bloom Realignment"],
      cta: "Book assessment",
    },
    "depilacao-a-laser": {
      name: "Laser Hair Removal",
      short: "Laser hair removal sessions performed by Lorena.",
      desc: "A personalised service for clients looking for progressive hair reduction with professional guidance and follow-up.",
      professional: "With Lorena",
      note: "The treatment plan and session frequency are defined individually after assessment.",
      items: ["Initial assessment", "Personalised session plan", "Laser hair removal by area", "Follow-up between sessions"],
      cta: "Book with Lorena",
      waMessage: "Hello! I saw the Bloom website and would like information or to book laser hair removal with Lorena.",
    },
    "limpeza-de-pele": {
      name: "Facial Cleansing",
      short: "Personalised facial care performed by Lorena.",
      desc: "A facial care experience focused on cleansing, preparation and skin comfort, adapted to each client's needs.",
      professional: "With Lorena",
      items: ["Skin assessment", "Cleansing", "Facial cleansing and care", "Face mask", "Finishing care and guidance"],
      cta: "Book with Lorena",
      waMessage: "Hello! I saw the Bloom website and would like information or to book a facial cleansing with Lorena.",
    },
    avaliacao: {
      name: "Professional Assessment",
      short: "The starting point of any safe transformation.",
      desc: "Complete hair and scalp diagnosis, with a strand test included whenever needed.",
    },
  },
  avaliacaoPage: {
    eyebrow: "Professional Assessment",
    title: "Everything begins with a proper assessment.",
    p: "Before any colour transformation, straightening or intensive treatment, we analyse your hair in detail. It is this care that makes results beautiful, safe and long-lasting.",
    itemsTitle: "What we analyse",
    items: [
      { t: "Strand condition", d: "Elasticity, porosity, strength and damage level." },
      { t: "Scalp", d: "Observation of the scalp's general condition." },
      { t: "Chemical history", d: "Previous colouring, bleaching and straightening." },
      { t: "Client's goal", d: "The result you want and what is feasible to achieve." },
      { t: "Technique and stages", d: "Definition of technique, time and possible phases." },
      { t: "Strand test", d: "Whenever needed, before chemical procedures." },
      { t: "Maintenance", d: "Guidance to maintain the result at home." },
    ],
    cta: "Book assessment via WhatsApp",
  },
  transformationsPage: {
    eyebrow: "Transformations",
    title: "Transformations that speak for themselves.",
    p: "Real results, built in a personalised way. Every hair has a story — these are some of them.",
    filters: { all: "All", antesDepois: "Before & After", coloracao: "Colour", balayage: "Balayage", progressiva: "Straightening", cortes: "Cuts" },
    slider: { before: "Before", after: "After" },
    captions: {
      balayage: "Balayage",
      progressiva: "Organic Straightening",
      corteBob: "Inverted Short Bob Cut",
      colocacao: "Hair Extensions",
      loiro: "Blonde",
      ruiva: "Copper Red Colour",
      videoLoiro: "Blonde — no filter",
      videoProg: "Organic Straightening",
      videoRuiva: "Copper Red Colour",
      moniquePro: "Monique Santos — Bloom Beauty Concept Hair",
    },
  },
  galleryPage: {
    eyebrow: "Gallery",
    title: "The Bloom universe in images",
    p: "The space, the details, the work and the essence of Bloom Beauty Concept Hair.",
    tags: { all: "Everything", coloracao: "Colour", balayage: "Balayage", progressiva: "Straightening", cortes: "Cuts" },
    captions: {
      balayage: "Balayage",
      progressiva: "Organic Straightening",
      corteBob: "Inverted Short Bob Cut",
      colocacao: "Hair Extensions",
      loiro: "Blonde",
      ruiva: "Copper Red Colour",
      videoLoiro: "Blonde — no filter",
      videoProg: "Organic Straightening",
      videoRuiva: "Copper Red Colour",
      moniquePro: "Monique Santos — Bloom Beauty Concept Hair",
    },
  },
  contactPage: {
    eyebrow: "Contact",
    title: "Shall we talk about your hair?",
    p: "We are in Venda do Pinheiro, doors open for you. Reach us on WhatsApp, Instagram or through the form.",
    addressTitle: "Address",
    phoneTitle: "Phone / WhatsApp",
    hoursTitle: "Opening hours",
    hoursWeek: "Monday to Friday",
    hoursWeekTime: "09:00 – 19:00",
    hoursSat: "Saturday",
    hoursSatTime: "09:30 – 18:00",
    formTitle: "Send a request",
    form: {
      name: "Name", namePh: "Your name",
      phone: "Phone", phonePh: "+351 …",
      email: "Email", emailPh: "youremail@example.com",
      service: "Service of interest",
      message: "Message", messagePh: "Tell us what you are looking for…",
      submit: "Send request",
      success: "Request sent! We will reply as soon as possible. If you prefer, talk to us right now on WhatsApp.",
      error: "Could not send. Please try again or reach us on WhatsApp.",
      required: "Please fill in your name and message.",
    },
    serviceOptions: ["Cut", "Colour", "Highlights", "Balayage", "Colour Correction", "Treatment", "Hair Schedule", "Botox", "Alignment", "Straightening", "Assessment", "Other"],
    whatsappCta: "Chat on WhatsApp",
    googleCta: "Review us on Google",
    googleTitle: "Bloom on Google",
    googleRating: "★★★★★ 5.0 · 2 reviews",
    googleNote: "Read the real reviews on our official profile or leave yours.",
    viewReviews: "See reviews",
    leaveReview: "Leave a review ⭐",
  },
  assistant: {
    name: "Bloom Assistant",
    status: "Online",
    greeting: "Hello! 🌸 Welcome to Bloom Beauty Concept Hair. How may I help you?",
    placeholder: "Type your message…",
    whatsapp: "Talk to Monique on WhatsApp",
    options: [
      { id: "eval", label: "I want to book an assessment" },
      { id: "services", label: "I want to explore the services" },
      { id: "mechas", label: "I have questions about highlights" },
      { id: "progressiva", label: "I want to know about straightening" },
      { id: "treatments", label: "I want to know about treatments" },
      { id: "location", label: "Where is the salon?" },
      { id: "hours", label: "What are the opening hours?" },
    ],
    answers: {
      eval: "With pleasure! The professional assessment is the first step: we analyse strand condition, scalp, chemical history and your goal — with a strand test when needed. Shall I forward you to Monique on WhatsApp to book?",
      services: "We work with Cuts & Styling, Colour, Illumination, Highlights & Balayage, Colour Correction, Hair Treatments, Hair Care Schedule, Botox & Alignment and Straightening. You can explore each specialty on the Services page.",
      mechas: "Illumination and highlights are created according to your cut, skin tone, natural base and goal. Colour transformations may require an assessment and a strand test — that is how we guarantee a beautiful, healthy result.",
      progressiva: "Straightening leaves hair aligned, shiny and frizz-free. The ideal technique depends on length, density and strand condition — which is why everything begins with an assessment.",
      treatments: "We offer hydration, nutrition, reconstruction, hair detox, cauterization and premium treatments. During the assessment we find out exactly what your hair needs — water, lipids or proteins.",
      location: "We are at Rua Casal dos Ninhos 1B, Venda do Pinheiro, 2665-536. On the Contact page you will find the 'Get directions' button.",
      hours: "Monday to Friday: 09:00–19:00. Saturday: 09:30–18:00. Sunday: closed.",
      price: "Prices vary with the service, length, density and condition of the hair — which is why we do not publish prices. Monique will gladly tell you everything on WhatsApp or during an assessment.",
      fallback: "To answer you with full attention, it is best to speak directly with Monique. Shall I forward you to WhatsApp?",
    },
    keywords: {
      eval: ["book", "booking", "appointment", "assessment", "schedule", "reserve"],
      price: ["price", "cost", "how much", "quote", "fee", "expensive", "cheap"],
      hours: ["hour", "open", "close", "saturday", "sunday", "when"],
      location: ["where", "address", "located", "location", "directions", "get there"],
      mechas: ["highlight", "balayage", "blonde", "blond", "babylight", "foil", "illumination"],
      progressiva: ["straight", "progressiva", "smoothing", "sleek"],
      treatments: ["treatment", "hydration", "nutrition", "reconstruction", "botox", "schedule", "frizz", "detox"],
      services: ["service", "cut", "colour", "color", "what do you do"],
    },
  },
  footer: {
    tagline: "We enhance your beauty, we reveal your essence.",
    nav: "Navigation", contact: "Contact", follow: "Follow us",
    hours: "Mon–Fri 09:00–19:00 · Sat 09:30–18:00",
    rights: "All rights reserved.",
    privacy: "Privacy Policy",
  },
  privacyPage: {
    title: "Privacy Policy",
    updated: "Last updated: September 2026",
    sections: [
      { t: "Data we collect", d: "When you contact us through the form or WhatsApp, we collect your name, phone number, email and your message, solely to answer your request and manage bookings." },
      { t: "How we use it", d: "Data is used exclusively to communicate with you about our services. We do not sell or share your data with third parties for marketing purposes." },
      { t: "Retention", d: "Data is kept only for as long as needed to handle your request and the client relationship." },
      { t: "Your rights", d: "You may request access, rectification or deletion of your data at any time by calling +351 963 085 891 or via Instagram @monique_santoshairstylist." },
      { t: "Cookies", d: "This website only uses anonymous analytics tools to improve the browsing experience." },
    ],
  },
  notFound: { title: "Page not found", p: "The address you are looking for does not exist or has been moved.", cta: "Back to home" },
  waDefault: "Hello Monique! I saw the Bloom Beauty Concept Hair website and would like information / to book an assessment.",
  waEval: "Hello Monique! I saw the Bloom website and would like to book a professional assessment.",
};

export default en;
